module.exports = __webpack_public_path__ + "static/angle-0bfbc87b6d7618f8d7d8bfb6ec3f430d.jpg";